import React from "react";
import { ChevronDoubleDownIcon, InboxIcon } from "@heroicons/react/24/outline";
import CustomBigText from "../sharedComponents/customBigText";
import image from "../../assets/images/serviceBuyImage.webp";
import imageTurkey from "../../assets/images/turkey.webp";
import imageOroba from "../../assets/images/oroba.webp";
import CustomButton from "../sharedComponents/customButton";
import { useTranslation } from "react-i18next";
import main from "../../assets/images/Group 1000016289.jpg";
import useLanguageDirection from "../../hooks/useLanguageDirection";
import { useLanguageNavigate } from "../../hooks/useLanguageNavigation";

const ServicesBuySection = () => {
  const { t } = useTranslation();
  const direction = useLanguageDirection();
  const navigateWithLang = useLanguageNavigate();

  const handleBuyForMe = () => {
    navigateWithLang("/explain-buy", { replace: false });
    window.location.reload(); 
  };

  return (
    <div className="relative pb-3 bg-[#121212] ">
      <img
        src={main}
        alt="Background"
        className="absolute inset-0 z-0 object-cover w-full h-full"
        style={{ opacity: 0.03 }}
        loading="lazy"
      />
      <div
        className="relative z-10 flex flex-col-reverse justify-around mb-5 md:flex-row max-container"
        dir={direction}
      >
        <div className="flex items-center justify-center md:w-1/2">
          <img src={image} alt="image" className="max-h-[450px] md:px-0 px-4" />
        </div>
        <div className="flex flex-col justify-between max-h-[550px] min-h-[500px] md:min-h-auto">
          <div className="flex flex-col items-center justify-center">
            <div className="flex items-center justify-between">
              {/* Line 1 */}
              <div
                className={`bg-yellow-50 w-[4px] h-[60px] md:h-[100px]  ${
                  direction === "rtl" ? "ml-24 md:ml-40" : "mr-24 md:mr-40"
                }`}
              ></div>
              {/* Space Between */}
              <div className="bg-yellow-50 w-[4px] h-[60px] md:h-[100px] "></div>
            </div>
            <CustomBigText title={t("servicesBuySection.title")} className="" />
          </div>

          <div>
            <p className="text-sm font-medium text-center text-white ">
              {t("servicesBuySection.description")}
            </p>
          </div>
          <div className="flex items-center justify-center gap-8">
            <div className="flex flex-col items-center justify-center">
              <ChevronDoubleDownIcon className="w-6 h-6 mb-2 text-white" />
              <img src={imageTurkey} alt="flag" className="w-20" />
              <div className="inline-block px-8 py-2 bg-custom-yellow ">
                <h2 className="text-sm font-bold text-black ">
                  {t("servicesBuySection.turkishStores")}
                </h2>
              </div>
            </div>
            <h2 className="text-2xl font-semibold text-white ">
              {t("allShippingSection.and")}
            </h2>
            <div className="flex flex-col items-center justify-center">
              <ChevronDoubleDownIcon className="w-6 h-6 mb-2 text-white" />
              <img src={imageOroba} alt="flag" className="w-20 " />
              <div className="inline-block px-8 py-2 bg-custom-yellow ">
                <h2 className="text-sm font-bold text-black">
                  {t("servicesBuySection.europeanStores")}
                </h2>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center pb-5 md:pb-0">
            <div className="">
              <p className="text-sm font-medium text-center text-white ">
                {t("servicesBuySection.descriptionTwo")}{" "}
              </p>
            </div>
            <ChevronDoubleDownIcon className="w-6 h-6 my-3 text-white" />
            <CustomButton
              children={t("servicesBuySection.buttonLabel")}
              icon={InboxIcon}
              onClick={handleBuyForMe}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default ServicesBuySection;
